<form novalidate #proxySetup="ngForm">
  <div class="setup proxy">
    <div class="close-cta">
      <i class="mdi mdi-close" mat-dialog-close></i>
    </div>
    <div class="section-container">
      <div class="label-data label">
        <div class="label">SIP proxy</div>
      </div>
      <div class="proxy-section">
        <div class="proxy-item"></div>
        <div class="proxy-item">
          <div
            class="proxy-item-wrapper"
            (click)="selectProxy('none')"
            [ngClass]="{ disable_none: disableNoneOption }"
          >
            <div class="proxy-icon">
              <i *ngIf="webProxyOption !== 'none'" class="mdi mdi-radiobox-blank"></i>
              <i *ngIf="webProxyOption === 'none'" class="blue-icon mdi mdi-radiobox-marked"></i>
            </div>
            <div class="proxy-item-content">
              <div class="label column">None</div>
              <div class="description">Do not use a proxy</div>
            </div>
          </div>
        </div>
        <div class="proxy-item custom-proxy">
          <div class="proxy-item-wrapper" (click)="selectProxy('custom')">
            <div class="proxy-icon">
              <i *ngIf="webProxyOption !== 'custom'" class="mdi mdi-radiobox-blank"></i>
              <i *ngIf="webProxyOption === 'custom'" class="blue-icon mdi mdi-radiobox-marked"></i>
            </div>
            <div class="proxy-item-content">
              <div class="label column">Custom</div>
              <div class="description">Configure a proxy for this test</div>
            </div>
          </div>

          <div *ngIf="webProxyOption === 'custom'">
            <div class="proxy-list-item group section-row">
              <div class="proxy-list-item custom">
                <div class="proxyCustomForm">
                  <div class="group">
                    <p class="groupLabel">User *</p>
                    <input
                      autocomplete="off"
                      class="alias customValue input-data"
                      [(ngModel)]="aliasName"
                      name="aliasName"
                      #aliasNameInput="ngModel"
                      placeholder="sign-in@address"
                      required
                    />
                    <div
                      class="error"
                      *ngIf="
                        aliasNameInput.invalid && (aliasNameInput.dirty || aliasNameInput.touched)
                      "
                    >
                      <mat-error *ngIf="aliasNameInput.errors.required">User is required</mat-error>
                    </div>
                    <div class="error" *ngIf="isOriDestSameUser">
                      <mat-error>User should be different for originator and destination</mat-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="label label-title"><b>Authentication</b></div>
            <div class="proxy-list-item group section-row">
              <div class="proxy-list-item custom">
                <div class="proxyCustomForm">
                  <div class="group">
                    <p class="groupLabel">Sign-in *</p>
                    <input
                      autocomplete="off"
                      class="alias input-data"
                      [(ngModel)]="authName"
                      #authNameInput="ngModel"
                      name="authName"
                      required
                    />
                    <div
                      class="error"
                      *ngIf="
                        authNameInput.invalid && (authNameInput.dirty || authNameInput.touched)
                      "
                    >
                      <mat-error *ngIf="authNameInput.errors.required">Name is required</mat-error>
                    </div>
                    <div class="error" *ngIf="isOriDestSameSignin">
                      <mat-error
                        >Authentication name should be different for originator and
                        destination</mat-error
                      >
                    </div>
                  </div>
                  <div class="group column-margin">
                    <p class="groupLabel">Password *</p>
                    <input
                      autocomplete="off"
                      type="password"
                      [(ngModel)]="authPassword"
                      #authPasswordInput="ngModel"
                      name="authPassword"
                      class="alias input-data"
                      required
                    />
                    <div
                      class="error"
                      *ngIf="
                        authPasswordInput.invalid &&
                        (authPasswordInput.dirty || authPasswordInput.touched)
                      "
                    >
                      <mat-error *ngIf="authPasswordInput.errors.required"
                        >Password is required</mat-error
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="label label-title"><b>Server Config</b></div>
            <div class="proxy-list-item group section-row">
              <div class="proxy-list-item custom">
                <div class="proxyCustomForm">
                  <div class="group">
                    <p class="groupLabel">Address *</p>
                    <input
                      autocomplete="off"
                      class="alias input-data"
                      [(ngModel)]="address"
                      #addressInput="ngModel"
                      name="address"
                      required
                      [matchPattern]="validAddressRegex"
                      maxlength="255"
                    />

                    <div
                      class="error"
                      *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)"
                    >
                      <mat-error *ngIf="addressInput.errors.required"
                        >Address is required</mat-error
                      >
                      <mat-error *ngIf="addressInput.errors.matchPattern"
                        >Address is invalid</mat-error
                      >
                    </div>
                  </div>
                  <div class="group column-margin">
                    <p class="groupLabel fw">UDP port *</p>
                    <input
                      type="number"
                      autocomplete="off"
                      name="port"
                      class="alias input-data"
                      [(ngModel)]="port"
                      #portInput="ngModel"
                      maxlength="5"
                      min="1"
                      max="65535"
                      required
                    />
                    <div
                      class="error"
                      *ngIf="portInput.invalid && (portInput.dirty || portInput.touched)"
                    >
                      <mat-error *ngIf="portInput.errors.required">Port is required.</mat-error>
                      <mat-error *ngIf="portInput.errors.max"
                        >Port range should be 1 to 65535</mat-error
                      >
                      <mat-error *ngIf="portInput.errors.min"
                        >Port range should be 1 to 65535</mat-error
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="control modal-footer">
            <button
              mat-flat-button
              mat-dialog-close
              class="save-btn"
              (click)="sendData()"
              [disabled]="isValidForm()"
            >
              ADD
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
